// extracted by mini-css-extract-plugin
export default {"btn":"PrintableReservationsRow_btn__xSz5R","table-number-cell":"PrintableReservationsRow_table-number-cell__4+mWM","tr":"PrintableReservationsRow_tr__Nlh9o"};